import React from 'react';
import { Mail } from 'lucide-react';
import { BUSINESS } from '../lib/site';

// "Email us" button for the top bar, in the coral from the logo: opens the
// visitor's email app with a message to the business already addressed.
const EMAIL_SUBJECT = 'Quote request from the Paint It Better website';

const EmailButton = ({ compact = false }) => (
  <a
    href={`mailto:${BUSINESS.email}?subject=${encodeURIComponent(EMAIL_SUBJECT)}`}
    aria-label="Email Paint It Better"
    title={`Email ${BUSINESS.email}`}
    className={`flex items-center justify-center gap-2 rounded-full bg-[#ff8151] text-slate-900 shadow-md hover:bg-[#ff6b35] transition-colors ${
      compact ? 'h-11 w-11' : 'h-9 px-5 text-sm font-medium'
    }`}
  >
    <Mail className={compact ? 'h-6 w-6' : 'h-4 w-4'} aria-hidden="true" />
    {!compact && <span>Email us</span>}
  </a>
);

export default EmailButton;
